export default __webpack_public_path__ + "static/martyniuk-bbfb4c8f5aa33393a57c30152ddd8c95.jpg";